export default {
  methods: {
    // Call SocketIO to update event on calendar
    ioCalendarStatus (payload) {
      this.$echo
        .private('Company.Calendar.' + this.company.id)
        .whisper('statusUpdate', payload)
    },
    // Call SocketIO to update event lock on calendar
    ioCalendarLock (payload) {
      this.$echo
        .private('Company.Calendar.' + this.company.id)
        .whisper('updateLock', payload)
    },
    // Call SocketIO to drag event on calendar
    ioCalendarDrag (params) {
      params.id = parseInt(params.id)
      this.$echo
        .private('Company.Calendar.' + this.company.id)
        .whisper('dragUpdate', params)

      this.$echo
        .private('Company.Appointment.' + params.id)
        .whisper('update', params.id)
    },
    // Call SocketIO to remove events from calendar
    ioCalendarRemove (ids) {
      this.$echo
        .private('Company.Calendar.' + this.company.id)
        .whisper('remove', ids)
    },
    // Call SocketIO to remove events from calendar (marked as unscheduled)
    ioCalendarUnscheduled (ids) {
      const newIds = []
      for (const id of ids) {
        newIds.push(parseInt(id))
      }

      this.$echo
        .private('Company.Calendar.' + this.company.id)
        .whisper('remove', newIds)

      for (const id of newIds) {
        this.$echo
          .private('Company.Appointment.' + id)
          .whisper('update', id)
      }
    },
    // Call SocketIO to add event to calendar
    ioCalendarAdd (appointments) {
      this.$echo
        .private('Company.Calendar.' + this.company.id)
        .whisper('add', appointments)
    },
    // Call SocketIO to add event to calendar
    ioCalendarUpdate (payload) {
      this.$echo
        .private('Company.Calendar.' + this.company.id)
        .whisper('update', payload)
    }
  }
}
